/*! @license Firebase v4.2.0
Build: rev-d6b2db4
Terms: https://firebase.google.com/terms/ */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.make = make;
exports.resolve = resolve;
exports.reject = reject;

var _promise = require('../../utils/promise');

function make(resolver) {
  return new _promise.PromiseImpl(resolver);
}
/**
 * @template T
 */
/**
* Copyright 2017 Google Inc.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/
/**
 * @fileoverview Implements the promise abstraction interface for external
 * (public SDK) packaging, which just passes through to the firebase-app impl.
 */
/**
 * @template T
 * @param {function((function(T): void),
 *                  (function(!Error): void))} resolver
 */
function resolve(value) {
  return _promise.PromiseImpl.resolve(value);
}
function reject(error) {
  return _promise.PromiseImpl.reject(error);
}
//# sourceMappingURL=promise_external.js.map



//////////////////
// WEBPACK FOOTER
// D:/ThinkBIT/work-projects/confe/hosting/~/firebase/storage/implementation/promise_external.js
// module id = ../../../../firebase/storage/implementation/promise_external.js
// module chunks = 22